//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { directive } from 'vue-awesome-swiper'
import 'swiper/swiper.scss'
export default {
  name: 'LandingSignup',
  directives: {
    swiper: directive
  },
  data () {
    return {
      showSlider: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 15,
        slidesPerGroup: 1,
        autoplay: {
          delay: 5000
        },
        draggable: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          991: {
            slidesPerView: 3
          },
          767: {
            slidesPerView: 3
          },
          320: {
            slidesPerView: 3
          }
        }
      },
      swiperOptions: {
        slidesPerView: 9,
        autoplay: {
          delay: 5000
        },
        draggable: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          991: {
            slidesPerView: 9
          },
          767: {
            slidesPerView: 9
          },
          320: {
            slidesPerView: 9
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      trends: 'coins/trends',
      buyDollarPrice: 'coins/buyDollarPrice'
    })
  },
  methods: {
    openTab () {
      const routeData = this.$router.resolve({ path: '/my/auth/register' })
      window.open(routeData.href, '_blank')
    }
  }
}
